module.exports = __webpack_public_path__ + "images/stickers/taco-cool@2x.3b9b13dd13effe08432a.png";